var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.notifications.showing)?_c('div',[_c('notifications')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }